import isNumber from 'lodash/isNumber';
import { INDENT } from '@yme/tokens/sizes';
import { TooltipPlacement } from './types';
const ARROW_TOOLTIP_SPACING = 16;
const SVG_SPACING = 4;
export const getTooltipStyles = (anchorEl, placement) => {
    const { top, left, width, height } = anchorEl.getBoundingClientRect();
    const scrolledTopPos = top + window.scrollY;
    const anchorHalfWidth = width / 2;
    const anchorHalfHeight = height / 2;
    const alignToEdge = anchorHalfWidth > ARROW_TOOLTIP_SPACING;
    let styles = {};
    let translateX;
    let translateY;
    switch (placement) {
        case TooltipPlacement.ABOVE_LEFT:
            translateX = alignToEdge ? 0 : anchorHalfWidth - SVG_SPACING;
            translateY = `calc(-100% - ${INDENT.xxxs})`;
            styles = {
                top: `${scrolledTopPos}px`,
                left: `${left}px`,
                transform: `translate(-${translateX}px, ${translateY})`,
            };
            break;
        case TooltipPlacement.ABOVE_CENTER:
            translateX = `calc(-50% + ${anchorHalfWidth}px)`;
            translateY = `calc(-100% - ${INDENT.xxxs})`;
            styles = {
                top: `${scrolledTopPos}px`,
                left: `${left}px`,
                transform: `translate(${translateX}, ${translateY})`,
            };
            break;
        case TooltipPlacement.ABOVE_RIGHT:
            translateX = alignToEdge
                ? `calc(-100% + ${width}px)`
                : `calc(-100% + ${width + anchorHalfWidth - SVG_SPACING}px)`;
            translateY = `calc(-100% - ${INDENT.xxxs})`;
            styles = {
                top: `${scrolledTopPos}px`,
                left: `${left}px`,
                transform: `translate(${translateX}, ${translateY})`,
            };
            break;
        case TooltipPlacement.BELOW_LEFT:
            translateX = alignToEdge ? 0 : anchorHalfWidth - SVG_SPACING;
            translateY = `${height + parseInt(INDENT.xxxs, 10)}px`;
            styles = {
                top: `${scrolledTopPos}px`,
                left: `${left}px`,
                transform: `translate(-${translateX}px, ${translateY})`,
            };
            break;
        case TooltipPlacement.BELOW_CENTER:
            translateX = `calc(-50% + ${anchorHalfWidth}px)`;
            translateY = `${height + parseInt(INDENT.xxxs, 10)}px`;
            styles = {
                top: `${scrolledTopPos}px`,
                left: `${left}px`,
                transform: `translate(${translateX}, ${translateY})`,
            };
            break;
        case TooltipPlacement.BELOW_RIGHT:
            translateX = alignToEdge
                ? `calc(-100% + ${width}px)`
                : `calc(-100% + ${width + anchorHalfWidth - SVG_SPACING}px)`;
            translateY = `${height + parseInt(INDENT.xxxs, 10)}px`;
            styles = {
                top: `${scrolledTopPos}px`,
                left: `${left}px`,
                transform: `translate(${translateX}, ${translateY})`,
            };
            break;
        case TooltipPlacement.LEFT:
            translateX = `calc(-100% - ${INDENT.xxxs})`;
            translateY = '-50%';
            styles = {
                top: `${scrolledTopPos + anchorHalfHeight}px`,
                left: `${left}px`,
                transform: `translate(${translateX}, ${translateY})`,
            };
            break;
        case TooltipPlacement.RIGHT:
        default:
            translateX = `${width + parseInt(INDENT.xxxs, 10)}px`;
            translateY = '-50%';
            styles = {
                top: `${scrolledTopPos + anchorHalfHeight}px`,
                left: `${left}px`,
                transform: `translate(${translateX}, ${translateY})`,
            };
            break;
    }
    return styles;
};
export const getDynamicTooltipStyles = (tooltipStyles, outerDynamicLeftCoord) => ({
    ...tooltipStyles,
    left: isNumber(outerDynamicLeftCoord) ? `${outerDynamicLeftCoord}px` : tooltipStyles?.left,
});
